import { ReactComponent as ExchangeIcon } from 'assets/images/exchange-icon.svg';
import { ReactComponent as DollarIcon } from 'assets/images/dollar-icon.svg';
import { ReactComponent as CoinIcon } from 'assets/images/coin-icon.svg';
import { ReactComponent as InfoIcon } from 'assets/images/faq-icon.svg';
import { ReactComponent as DocIcon } from 'assets/images/doc-icon.svg';
import { ReactComponent as BridgeIcon } from 'assets/images/bridge.svg';




import ROUTES from 'constants/routes';

const config = [
  {
    id: 0,
    label: 'Trade',
    icon: ExchangeIcon,
    href: ROUTES.TRADE,
    extlink: true,

  },
  {
    id: 1,
    label: 'Stake',
    icon: DollarIcon,
    href: ROUTES.STAKE,
  },
  {
    id: 2,
    label: 'Token Creator',
    icon: CoinIcon,
    href: ROUTES.TOKEN_CREATOR,
  },
   {
    id: 3,
    label: 'Bridge',
    icon: BridgeIcon,
    href: ROUTES.BRIDGE,
    extlink: true,
  },
  {
    id: 4,
    label: 'FAQ',
    icon: InfoIcon,
    href: ROUTES.FAQ,
  },
  {
    id: 5,
    label: 'Docs',
    icon: DocIcon,
    href: ROUTES.DOCS,
    extlink: true,
  },
];

// const config = [
//   // {
//   //   id: 0,
//   //   label: 'Trade',
//   //   icon: ExchangeIcon,
//   //   href: ROUTES.TRADE,
//   // },
//   {
//     id: 0,
//     label: 'Stake',
//     icon: DollarIcon,
//     href: ROUTES.STAKE,
//   },
//   {
//     id: 1,
//     label: 'Token Creator',
//     icon: CoinIcon,
//     href: ROUTES.TOKEN_CREATOR,
//   },
//   {
//     id: 2,
//     label: 'FAQ',
//     icon: InfoIcon,
//     href: ROUTES.FAQ,
//   },
//   {
//     id: 3,
//     label: 'Docs',
//     icon: DocIcon,
//     href: ROUTES.DOCS,
//     extlink: true,
//   },
// ];

export default config;
